/* eslint func-names: ["error", "never", { "generators": "as-needed" }] */
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.locale('id');
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.updateLocale('id', {
  relativeTime: {
    future: '%s lagi',
    past: '%s lalu',
    s: 'sesaat',
    m: 'semenit',
    mm: '%d menit',
    h: 'sejam',
    hh: '%d jam',
    d: 'sehari',
    dd: '%d hari',
    M: 'sebulan',
    MM: '%d bulan',
    y: 'setahun',
    yy: '%d tahun'
  }
});

export const timeAgo = (val: string, sqlMode: Boolean) => {
  if (!val) return '';
  let format = 'MM-DD-YYYY';
  if (sqlMode === true) format = 'YYYY-MM-DD HH:mm:ss';

  const cleanDate = dayjs(val.trim(), format);
  return dayjs(cleanDate).tz('Asia/Jakarta').fromNow();
};

export const simpleTimeAgo = (val: string, sqlMode: Boolean) => {
  if (!val) return '';
  let format = 'MM-DD-YYYY';
  if (sqlMode === true) format = 'YYYY-MM-DD HH:mm:ss';

  const cleanDate = dayjs(val.trim(), format);
  return dayjs(cleanDate).tz('Asia/Jakarta').fromNow(true);
};

export const indoDate = function (val: string, sqlMode: Boolean) {
  if (!val) return '';
  let format = 'MM-DD-YYYY';
  if (sqlMode === true) format = 'YYYY-MM-DD HH:mm:ss';
  const cleanDate = dayjs(val.trim(), format);
  return dayjs(cleanDate).tz('Asia/Jakarta').format('DD MMMM YYYY HH:mm') + ' WIB';
};
export const shortIndoDate = function (val: string, sqlMode: Boolean) {
  if (!val) return '';
  let format = 'MM-DD-YYYY';
  if (sqlMode === true) format = 'YYYY-MM-DD HH:mm:ss';
  const cleanDate = dayjs(val.trim(), format);
  return dayjs(cleanDate).tz('Asia/Jakarta').format('DD MMM YYYY HH:mm') + ' WIB';
};

export const randomNumberBetween = (min: number, max: number) =>
  Math.floor(Math.random() * (max - min + 1) + min);

export const strCut = (str: string, limit: number) => {
  if (!str || !limit) return;
  if (str.length > limit) {
    return str.substring(0, limit - 1).trim() + '...';
  }
  return str;
};

export const strCutStripped = (str: string, limit: number) => {
  if (!str || !limit) return;
  const regex = /(<([^>]+)>)/gi;
  const stripped = str.replace(regex, '');
  return strCut(stripped, limit);
};

export const fileSize = (size: number) => {
  let result = null;
  if (!size) return result;

  if (size < 1024) {
    result = `${size.toString()} B`;
  }
  if (size > 1024) {
    result = `${(size / 1024).toFixed(2)} KB`;
  }
  if (size > 1024 * 1024) {
    result = `${(size / 1024 / 1024).toFixed(2)} MB`;
  }
  if (size > 1024 * 1024 * 1024) {
    result = `${(size / 1024 / 1024 / 1024).toFixed(2)} GB`;
  }
  if (size > 1024 * 1024 * 1024 * 1024) {
    result = `${(size / 1024 / 1024 / 1024 / 1024).toFixed(2)} TB`;
  }

  return result;
};

export const arrayBufferToString = (buffer: Uint8Array) => {
  const arr = new Uint8Array(<ArrayBuffer>buffer);
  const str = String.fromCharCode.apply(null, [...new Uint8Array(arr)]);
  if (/[\u0080-\uffff]/.test(str)) {
    throw new Error('this string seems to contain (still encoded) multibytes');
  }
  return str;
};

export const apply_blob = (element: any, image: any) => {
  new Blob([image]).text().then((value) => (element.value = value));
};

export const getFileExtension = (filename: string) => filename.split('.').pop();
export const periodData = (tipe: string, data: string) => {
  if (tipe === 'Tahun') {
    return data.split(' ').pop();
  }
  return data;
};

export const removeFromArray = (original: any, remove: any) => {
  if (!original) {
    return [];
  }
  return original.filter((value: any) => !remove.includes(value));
};

export const addToArray = (original: any, newData: any) => {
  if (!newData) return;
  return original.concat(newData);
};

export const compareArray = (arr1: any, arr2: any) => {
  if (arr1.length != arr2.length) {
    return false;
  } else {
    const sortArr1 = arr1.sort();
    const sortArr2 = arr2.sort();
    let result = false;
    // comparing each element of array
    for (let i = 0; i < sortArr1.length; i++) {
      if (sortArr1[i] != sortArr2[i]) {
        return false;
      } else {
        result = true;
      }
    }
    return result;
  }
};

export const getCookie = (cookiename: string) => {
  const cookiestring = document.cookie;
  const cookiearray = cookiestring.split(';');
  for (let i = 0; i < cookiearray.length; ++i) {
    if (cookiearray[i].trim().match('^' + cookiename + '=')) {
      return cookiearray[i].replace(`${cookiename}=`, '').trim();
    }
  }
  return null;
};

export const screenType = () => {
  const wPixel = window.innerWidth;
  let result = 'lg';

  if (wPixel >= 320) result = 'sm';
  if (wPixel >= 720) result = 'md';
  if (wPixel >= 1150) result = 'lg';
  if (wPixel >= 1200) result = 'xl';
  if (wPixel >= 1900) result = '2xl';
  return result;
};

export const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

//fungsi dekriptor data dari backend
//agar data lebih aman; backend akan mengirim data terenkripsi
//oleh frontend akan didekripsi menjadi data yang bisa dibaca
//jadi per-user-per-browser datanya unik
// export const decryptData = (data: string) => {
//   const CryptoJS = require('crypto-js')

//   const iv = CryptoJS.enc.Hex.parse(data.substring(0, 32))
//   const ct = CryptoJS.enc.Hex.parse(data.substring(32))
//   const key = CryptoJS.enc.Utf8.parse('6368616e676520746869732070617373') //ini harus dinamis (diberikan oleh backend)
//   // @ts-ignore
//   const decrypted = CryptoJS.AES.decrypt({ ciphertext: ct }, key, {
//     mode: CryptoJS.mode.CBC,
//     iv: iv
//   })

//   return decrypted.toString(CryptoJS.enc.Utf8)
// }

export const boolValue = (val: string) => val.toLowerCase() === 'true';

//membersihkan form yang akan disubmit
export const clearFormData = (data: any) => {
  //bersihkan model dari null value dan empty string
  //untuk dikirim ke backend
  const removeEmpty: any = (obj: any) =>
    Object.keys(obj)
      .filter((f) => obj[f] != null)
      .filter((f) => obj[f] != undefined)
      // .filter(f => obj[f] != [])
      .filter((f) => obj[f] != '')
      .reduce(
        (r, i) =>
          typeof obj[i] === 'object'
            ? { ...r, [i]: removeEmpty(obj[i]) } // recurse.
            : { ...r, [i]: obj[i] },
        {}
      );

  const clearData = removeEmpty(data);
  const formData = new FormData();
  for (const key in clearData) {
    formData.append(key, clearData[key]);
  }
  return formData;
};

export const isValidURL = (theUrl: string) => {
  const regex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
  return regex.test(theUrl);
};

export const debounce = (func: Function, wait: number) => {
  let timeout: NodeJS.Timeout | null = null;
  return function (...args: any[]) {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

export const getMimeType = (fileSource: any, fallback = null) => {
  const byteArray = new Uint8Array(fileSource).subarray(0, 4);
  let header = '';
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case '89504e47':
      return 'image/png';
    case '47494638':
      return 'image/gif';
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
    case 'ffd8ffe3':
    case 'ffd8ffe8':
      return 'image/jpeg';
    default:
      return fallback;
  }
};
